import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import MetalsTracker from './pages/MetalsTracker';
import reportWebVitals from './reportWebVitals';

const path = window.location.pathname;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {path === '/metals' ? <MetalsTracker /> : <App />}
  </React.StrictMode>
);

reportWebVitals();
